// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Checkbox, CheckboxProps } from 'antd';
import React, { ReactElement } from 'react';
import { Group } from './Group';

import './THCheckbox.scss';

type THCheckboxProps = CheckboxProps;

export const THCheckbox = ({ className, ...props }: THCheckboxProps): ReactElement => (
    <Checkbox className={classList('th-checkbox', className)} {...props} />
);

THCheckbox.Group = Group;
